import { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { LineChart, CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [message, setMessage] = useState("");
  const nav = useNavigate();

  useEffect(() => {
    if (!token) {
      setStatus("error"); setMessage("Missing verification token.");
      return;
    }
    api.get(`/auth/verify-email?token=${encodeURIComponent(token)}`)
       .then((r) => { setStatus("success"); setMessage(r.data.email || ""); })
       .catch((e) => {
         setStatus("error");
         setMessage(e.response?.data?.detail || "Verification link is invalid or expired.");
       });
  }, [token]);

  return (
    <div className="min-h-screen bg-[#09090B] text-zinc-100 flex items-center justify-center p-5">
      <div className="w-full max-w-md border border-white/10 bg-[#121214] rounded-sm p-6 sm:p-8 text-center">
        <div className="flex items-center justify-center gap-2 mb-6">
          <LineChart className="w-5 h-5 text-teal-400" strokeWidth={1.5} />
          <div className="font-mono text-sm tracking-widest uppercase">BonBot</div>
        </div>

        {status === "verifying" && (
          <>
            <div className="text-2xl font-medium mb-2">Verifying your email…</div>
            <p className="text-zinc-500 text-sm">One second.</p>
          </>
        )}

        {status === "success" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-teal-400 mx-auto mb-3" strokeWidth={1.5} />
            <div className="text-2xl font-medium tracking-tight mb-2">You're verified.</div>
            <p className="text-zinc-500 text-sm mb-6">{message ? `${message} is now active.` : "Your account is now active."}</p>
            <Link to="/login" data-testid="verified-continue-link"
                  className="inline-block bg-teal-400 text-[#09090B] hover:bg-teal-300 px-6 py-2.5 text-sm font-mono uppercase tracking-widest rounded-sm font-medium">
              Continue to sign in
            </Link>
          </>
        )}

        {status === "error" && (
          <>
            <XCircle className="w-12 h-12 text-rose-400 mx-auto mb-3" strokeWidth={1.5} />
            <div className="text-2xl font-medium tracking-tight mb-2">Verification failed</div>
            <p className="text-zinc-500 text-sm mb-6">{message}</p>
            <Link to="/login" className="text-zinc-400 hover:text-zinc-100 text-sm font-mono uppercase tracking-widest">Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
